export const TENANT_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
};

export const SUBDOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export function mapTenantFromApi(tenant = {}) {
  return {
    id: tenant.id || '',
    name: tenant.name || '',
    email: tenant.email || '',
    business_domain: tenant.business_domain || '',
    subdomain: tenant.subdomain || '',
    status: tenant.status || TENANT_STATUS.ACTIVE,
    createdAt: tenant.createdAt || '',
    updatedAt: tenant.updatedAt || '',
  };
}

export function mapTenantListResponse(payload = {}) {
  const tenants = Array.isArray(payload.tenants) ? payload.tenants : [];
  return tenants.map(mapTenantFromApi);
}

export function toCreateTenantPayload(values = {}) {
  return {
    name: (values.name || '').trim(),
    email: (values.email || '').trim(),
    business_domain: (values.business_domain || '').trim() || null,
    subdomain: (values.subdomain || '').trim().toLowerCase(),
  };
}

export function toUpdateTenantPayload(values = {}) {
  return {
    name: (values.name || '').trim(),
    email: (values.email || '').trim(),
    business_domain: (values.business_domain || '').trim() || null,
  };
}

export function toStatusPayload(status) {
  return {
    status,
  };
}
